module.exports = __webpack_public_path__ + "media/icons/health-34c7391c157dee3497db876501133fd7.svg";